module.exports = __webpack_public_path__ + "media/application/images/svgs/instagram-341a67c538d67f9ce92005cf14255dc2.svg";